import axios from "axios";
import VueAxios from "vue-axios";

// Десеарилизатор даты
if (JSON && !JSON.dateParser) {
  const reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):((\d{2})|(\d{2}(?:\.\d*)))(?:Z|(\+|-)([\d|:]*))?$/
  const reMsAjax = /^\/Date\((d|-|.*)\)[/|\\]$/

  JSON.dateParser = function (key, value) {
    if (typeof value === 'string') {
      var a = reISO.exec(value)
      if (a) {
        return new Date(value)
      }
      a = reMsAjax.exec(value)
      if (a) {
        var b = a[1].split(/[-+,.]/)
        return new Date(b[0] ? +b[0] : 0 - +b[1])
      }
    }
    return value
  }
}

export default {
  install(Vue) {
    // axios.defaults.baseURL = process.env.VUE_APP_API_BASE || "http://127.0.0.1:8000/api";

    const API_BASE = process.env.NODE_ENV === 'development' ? '/api' : process.env.VUE_APP_API_BASE || "/api"
    // const API_BASE = process.env.VUE_APP_API_BASE || "http://127.0.0.1:8000/api"
    var instance = axios.create({
      baseURL: API_BASE,
      timeout: 10000,
    });

    // axios.interceptors.request.use(function (config) {
    //   // Do something before request is sent
    //   debugger
    //   if (config.url.startsWith(config.baseURL)) {
    //     const token = localStorage.getItem('access_token', null)
    //     if (token) {
    //       config.headers.authorization = 'Bearer ' + localStorage.getItem("access_token");
    //     }
    //   }
    //   return config;
    // }, function (error) {
    //   // Do something with request error
    //   return Promise.reject(error);
    // });


    Vue.use(VueAxios, instance);
    Vue.axios.defaults.baseURL = API_BASE
    Vue.axios.interceptors.response.use(function (response) {
      // Десериализация дат
      if (response.headers['content-type'] === 'application/json') {
        response.rawData = response.data
        response.data = JSON.parse(response.request.responseText, JSON.dateParser)
      }
      return response
    }, function (error) {
      return Promise.reject(error)
    })
  }
}
